import { AfterViewChecked, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TicketDetailsComponent } from '../../ticket-details.component';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { RightPanelService } from 'src/app/core/services/right-panel.service';
import { RightPanelType } from 'src/app/core/enums/right-panel-type.enum';
import { ReplyStoreService } from 'src/app/core/services/ticket/reply-store.service';
import { HelperService } from 'src/sb-tools/typescript/services/helper.service';
import { QuillHelperService } from 'src/sb-tools/typescript/services/quill/quill-helper.service';
import { ReplyService } from 'src/app/core/services/ticket/reply.service';
import { UserService } from 'src/sb-tools/typescript/services/user.service';
import { NoteService } from '../../../core/services/note.service';
import { SmilesService } from 'src/sb-tools/typescript/services/smiles.service';
import { ReplySortingService } from 'src/app/core/services/ticket/reply-sorting.service';
import { ReplyUpdateModel } from '@sb-tools/typescript/models/reply-update-model.model';
import { BACKSPACE, COMMA, ENTER, SEMICOLON, SPACE } from 'src/sb-tools/typescript/constants/keycodes';
import { ThreadFilterService } from '../../../core/services/thread-filter.service';
import { combineLatest, debounceTime, Subject, take, takeUntil } from 'rxjs';
import { ReplyDataService } from 'src/app/core/services/ticket/reply-data.service';
import { ReplyTemplateService } from '../../../../sb-modules/Frontend-Reply-Templates-Module/core/reply-template.service';
import { TypeaheadDirective, TypeaheadMatch, TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ContactService } from '@sb-tools/typescript/services/contact.service';
import { AddressBookContactDTO } from '@sb-tools/typescript/models/dto/address-book-contact.dto';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { MessageThreadElementType } from '@sb-tools/typescript/enums/message-thread-element-type.enum';
import { WithLabelRecipients } from '../../../core/models/with-label-recipients.model';
import { DetailedTicketDTO } from '../../../core/models/dto/detailed-ticket.dto';
import { EmailRecipients } from '../../../core/models/email-recipients.model';
import { ThreadSortControlComponent } from '../thread-sort-control/thread-sort-control.component';
import { NgClass } from '@angular/common';
import { TicketMainMessageComponent } from '../ticket-main-message/ticket-main-message.component';
import { ThreadExpanderComponent } from '../thread-expander/thread-expander.component';
import { TicketWebReplyComponent } from './ticket-web-reply/ticket-web-reply.component';
import { ThreadSurveyResultComponent } from '../thread-survey-result/thread-survey-result.component';
import { SessionAuthenticationEventComponent } from '../session-authentication-event/session-authentication-event.component';
import { SuggestionsComponent } from '../suggestions/suggestions.component';
import { UserAvatarComponent } from '../../../../sb-modules/Frontend-User-Avatar-Module/user-avatar.component';
import { TagsInputComponent } from '../../../../sb-modules/Frontend-form-field-module/tags-input/tags-input.component';
import { ClipboardModule } from 'ngx-clipboard';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FormsModule } from '@angular/forms';
import { QuillReplyTemplatesComponent } from '../../../../sb-modules/Frontend-Reply-Templates-Module/quill-reply-templates/quill-reply-templates.component';
import { WebReplyQuillEditorComponent } from '../../../shared/components/web-reply-quill-editor/web-reply-quill-editor.component';
import { QuillEmojiPickerComponent } from '../../../../sb-tools/typescript/components/quill-emoji-picker/quill-emoji-picker.component';
import { FilePreviewComponent } from '../../../../sb-modules/Frontend-Document-Viewer-Module/components/file-preview/file-preview.component';
import { IsInvalidMessagePipe } from '../../../../sb-tools/typescript/pipes/ticket/is-invalid-message.pipe';
import { TruncatePipe } from '../../../../sb-tools/typescript/pipes/truncate.pipe';
import { FilterRepliesPipe } from '../../../shared/pipes/filter-replies.pipe';
import { ArrayToStringPipe } from '../../../shared/pipes/array-to-string.pipe';
import { LocalStorageService } from '@sb-tools/typescript/services/local-storage.service';

const stickyKeyName = 'isStickyEditor';

@Component({
    selector: 'app-ticket-thread-web',
    templateUrl: './ticket-thread-web.component.html',
    styleUrls: ['./ticket-thread-web.component.scss'],
    imports: [
        ThreadSortControlComponent,
        NgClass,
        TicketMainMessageComponent,
        ThreadExpanderComponent,
        TicketWebReplyComponent,
        ThreadSurveyResultComponent,
        SessionAuthenticationEventComponent,
        SuggestionsComponent,
        UserAvatarComponent,
        TranslateModule,
        TagsInputComponent,
        ClipboardModule,
        InlineSVGComponent,
        TooltipModule,
        FormsModule,
        TypeaheadModule,
        QuillReplyTemplatesComponent,
        WebReplyQuillEditorComponent,
        QuillEmojiPickerComponent,
        FilePreviewComponent,
        IsInvalidMessagePipe,
        TruncatePipe,
        FilterRepliesPipe,
        ArrayToStringPipe,
    ],
})
export class TicketThreadWebComponent implements OnInit, AfterViewChecked, OnDestroy {
    @ViewChild('outboundEmailAddressSelector') outboundEmailAddressSelector: TypeaheadDirective;

    autoSignatureHTMLContent: string;
    isEmailValid = HelperService.isEmailValid;
    isOnlyAutoSignatureSet = false;
    isShouldBeLoggedInCrm: boolean;
    isShowBccField = false;
    isShowCcField = false;
    isShowFromField: boolean;
    isSticky: boolean;
    // todo: remove when postnord start using chat view
    isToAndCcHidden: boolean;
    newReply: ReplyUpdateModel;
    quillConfig: unknown;
    recipientsUpdate = new Subject<WithLabelRecipients>();
    rightPanelTypeEnum = RightPanelType;
    selectedOutboundEmailAddress: string;
    selectedOutboundEmailAddresses: string[] = [];
    separatorKeys = [SPACE, ENTER, COMMA, SEMICOLON];
    threadFilterService = ThreadFilterService;
    ticket: DetailedTicketDTO;
    toUsers: BaseUserWithRole[] = [];
    users: (BaseUserWithRole | AddressBookContactDTO)[] = [];

    private unsubscriber = new Subject<void>();

    constructor(
        @Inject(TicketDetailsComponent) public parent: TicketDetailsComponent,
        public commonDataService: CommonDataService,
        public noteService: NoteService,
        public quillHelperService: QuillHelperService,
        public replySortingService: ReplySortingService,
        public replyTemplateService: ReplyTemplateService,
        public rightPanelService: RightPanelService,
        private contactService: ContactService,
        private localStorageService: LocalStorageService,
        private replyDataService: ReplyDataService,
        private replyService: ReplyService,
        private replyStoreService: ReplyStoreService,
        private smilesService: SmilesService,
        private translateService: TranslateService,
        private userService: UserService,
    ) {
        this.ticket = parent.ticket;
        this.newReply = this.parent.newReply;
        this.quillConfig = this.quillHelperService.htmlQuillConfig;

        this.isToAndCcHidden = ['postnordsverige', 'postnordsetest', 'nataliatestdev', 'nataliafirsttest'].includes(
            commonDataService.community.toLowerCase(),
        );

        this.isSticky = this.localStorageService.getItem(stickyKeyName) !== 'false';
    }

    ngOnInit(): void {
        combineLatest([this.contactService.getAllFromCache(), this.userService.getAll()])
            .pipe(takeUntil(this.unsubscriber), take(1))
            .subscribe(([contacts, users]) => {
                contacts.forEach((contact) => {
                    contact.label = contact.name + ' ' + contact.email;
                    contact.typeName = this.translateService.instant('Contacts');
                    contact.isContact = true;
                });
                users.forEach((user) => {
                    user.label = user.name ? user.name + ' ' + user.email : user.email;
                    user.typeName = this.translateService.instant('Teammates');
                });

                this.users = [...contacts, ...users];

                if (this.ticket.defaultReplyRecipients.cc.length) {
                    this.parent.ccUsers = this.getSelectedUsersList(this.ticket.defaultReplyRecipients.cc);
                }

                if (this.ticket.defaultReplyRecipients.to.length) {
                    this.toUsers = this.getSelectedUsersList(this.ticket.defaultReplyRecipients.to);
                }

                if (this.parent.ticket.outboundEmailAddress) {
                    this.isShowFromField = true;
                    this.selectedOutboundEmailAddresses[0] = this.parent.ticket.outboundEmailAddress;
                }
            });

        this.recipientsUpdate
            .pipe(debounceTime(700), takeUntil(this.unsubscriber))
            .subscribe((withLabelRecipients: WithLabelRecipients) => {
                const toUsers = withLabelRecipients.to.map((u) => u.email);
                const ccUsers = withLabelRecipients.cc.map((u) => u.email);
                const bccUsers = withLabelRecipients.bcc.map((u) => u.email);
                this.validateReplyRecipients({ to: toUsers, cc: ccUsers, bcc: bccUsers });
            });
    }

    ngAfterViewChecked(): void {
        this.replyService.initializeNewReplyEditor();
    }

    addAutoSignature(): void {
        this.newReply.message.html = this.autoSignatureHTMLContent;
    }

    addOutboundEmailAddress(event: TypeaheadMatch, callback?: () => void): void {
        this.selectedOutboundEmailAddresses[0] = event.item;

        if (callback) {
            callback();
        }

        this.selectedOutboundEmailAddress = '';
    }

    checkAndAddNewEmail(callback?: () => void): void {
        if (HelperService.isEmailValid(this.selectedOutboundEmailAddress)) {
            this.selectedOutboundEmailAddress = this.selectedOutboundEmailAddress.toLowerCase();

            this.addOutboundEmailAddress(
                {
                    item: this.selectedOutboundEmailAddress,
                } as TypeaheadMatch,
                callback,
            );
        }
    }

    keyDownHandler(event): boolean {
        if (this.separatorKeys.includes(event.keyCode)) {
            const cleanSearchTextCallback = () => {
                event.target.value = '';
            };
            this.checkAndAddNewEmail(cleanSearchTextCallback);
            return false;
        }

        if (event && event.keyCode === BACKSPACE && !event.target.value) {
            this.selectedOutboundEmailAddresses = [];
        }
    }

    onReplyChanged(data): void {
        this.isOnlyAutoSignatureSet = data.html && !this.newReply.message.html;

        if (this.isOnlyAutoSignatureSet) {
            this.autoSignatureHTMLContent = data.html;
        }

        this.newReply.message.text = HelperService.strip(
            this.smilesService.replaceImagesToCodes(this.newReply.message.html),
            false,
        );

        this.replyStoreService.saveTempReply(this.newReply.message);
        this.replyService.controlVisibilityOfNewReplyField(this.replySortingService.replySortBy);
    }

    removeOutboundEmailAddress(): void {
        this.selectedOutboundEmailAddresses = [];
    }

    showAndFocusCcField(): void {
        this.isShowCcField = true;
        setTimeout(() => {
            const users = document.querySelectorAll('[data-reply-id]');
            (users[users.length - (this.isShowBccField ? 2 : 1)] as HTMLElement).focus();
        }, 100);
    }

    showAndFocusBccField(): void {
        this.isShowBccField = true;
        setTimeout(() => {
            const users = document.querySelectorAll('[data-reply-id]');
            (users[users.length - 1] as HTMLElement).focus();
        }, 100);
    }

    showAndFocusFromField(): void {
        this.isShowFromField = true;

        this.outboundEmailAddressSelector.isFocused = true;
    }

    validateReplyRecipients(emailRecipients: EmailRecipients): void {
        this.newReply.isRecipientChangeConfirmed = null;
        this.replyDataService
            .validateReplyRecipients(this.ticket.id, emailRecipients)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((result) => {
                this.newReply.isRecipientChangeConfirmed = result;
            });
    }

    private getSelectedUsersList(emailList: string[]): BaseUserWithRole[] {
        const usersList = [];

        emailList.forEach((email: string) => {
            let selectedUser = this.users.find((user) => {
                return user.email.toLowerCase() === email?.toLowerCase();
            });

            if (!selectedUser) {
                selectedUser = { email, label: email } as BaseUserWithRole;
            }
            usersList.push(selectedUser);
        });

        return usersList;
    }

    toggleStickyState(): void {
        this.isSticky = !this.isSticky;
        this.localStorageService.setItem(stickyKeyName, this.isSticky.toString());
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }

    protected readonly messageThreadElementTypeEnum = MessageThreadElementType;
}
